import isMobile from './utils/isMobile'

const env = process.env.NODE_ENV

const isMobileObj = isMobile()

export default config = Object.freeze({
    // Environments
    ENV: env,
    IS_DEV: env === 'development',
    IS_PROD: env === 'production',

    // Device
    IS_TOUCH: isMobileObj?.phone || isMobileObj?.tablet,
})
